import { useState, useEffect } from "react";
import { encryptForStorage } from "../secure/secureStorage"; 

const useWorkspaces = (user) => {
  const [workspaces, setWorkspaces] = useState(() => {
    const saved = localStorage.getItem("my_local_workspaces");
    return saved ? JSON.parse(saved) : [];
  });
  
  const [activeWorkspaceId, setActiveWorkspaceId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem("my_local_workspaces", JSON.stringify(workspaces));
    
    if (workspaces.length > 0 && !activeWorkspaceId) {
      setActiveWorkspaceId(workspaces[0].id);
    }
  }, [workspaces, activeWorkspaceId]);



const addWorkspace = async (email, password, name, passphrase) => {
    setIsLoading(true);
    try {
        const activePassphrase = passphrase || sessionStorage.getItem("yassu_pf") || "";
        const encryptedPassword = await encryptForStorage(password, activePassphrase);

        const newWorkspace = {
            id: "local_" + Date.now(),
            email: email,
            password: encryptedPassword, 
            accountName: name,
        };

        setWorkspaces((prev) => [...prev, newWorkspace]);
        return true;
    } catch (error) {
        console.error("Encryption failed:", error);
        throw error;
    } finally {
        setIsLoading(false);
    }
};


  const removeWorkspace = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this workspace locally?");
    if (!confirmDelete) return;

    const updatedWorkspaces = workspaces.filter((ws) => ws.id !== id);
    setWorkspaces(updatedWorkspaces);

    if (activeWorkspaceId === id) {
      setActiveWorkspaceId(updatedWorkspaces.length > 0 ? updatedWorkspaces[0].id : null);
    }
  };

  const activeWorkspace = workspaces.find((ws) => ws.id === activeWorkspaceId) || null;

  const refreshWorkspaces = () => {
    const saved = localStorage.getItem("my_local_workspaces");
    if (saved) {
      setWorkspaces(JSON.parse(saved));
    }
  };

  return {
    workspaces,
    activeWorkspaceId,
    setActiveWorkspaceId,
    activeWorkspace, 
    addWorkspace,
    removeWorkspace,
    refreshWorkspaces,
    isLoading,
  };
};

export default useWorkspaces;